/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ccActions.jsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Sep 19, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali
 * On            : Sep 19 2019
 * Description   : ASDS-165
 * 
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes. Removed alerts.
 * 
 ******************************************************************************/

import CheckoutConstants from '../constants/checkout-constants';
import { logInfo, logError } from '../../../utils/console-utility';

export function IFrame_OnLoad() {
    const iframe = document.getElementsByName('dieCommFrame');
    if (iframe) {
        window.$XIFrame.onload({
            iFrameId: 'dieCommFrame',
            targetUrl: iframe[0].getAttribute("src"),
            autosizeheight: true,
            autosizewidth: true,
            onSuccess: function () {
                logInfo('A form for the merchant guid and access token combination is loading in the iFrame successfully.');
            },
            onError: function () {
                logInfo('A form for the merchant guid and access token combination has FAILED to load.');
            },
        });
    }
}

let isSubmitCCSuccess;

export function submitCCFrom() {
    const iframe = document.getElementsByName('dieCommFrame');
    isSubmitCCSuccess = CheckoutConstants.CC_PROCESS_INITIATED;
    if (iframe) {
        window.$XIFrame.submit({
            iFrameId: 'dieCommFrame',
            targetUrl: iframe[0].getAttribute("src"),
            onSuccess: function (msg) {
                const message = JSON.parse(msg);
                if (message && message.data.HasPassed) {
                    isSubmitCCSuccess = CheckoutConstants.CC_PROCESS_SUCCESS;
                } else {
                    logError(message.data.Message);
                    isSubmitCCSuccess = CheckoutConstants.CC_PROCESS_FAILED;
                }
            },
            onError: function (msg) {
                logError(msg);
                isSubmitCCSuccess = CheckoutConstants.CC_PROCESS_FAILED;
            },
        });
    }
}

export const getSubmitSuccessValue = () => {
    return isSubmitCCSuccess;
}